// 9fbef606107a605d69c0edbcd8029e5d
/* eslint-disable max-lines */
/** @module ProductBasicInfo
 * @summary Show the product's name, rating and wishlist CTA.
 */

import React from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import {
  isBVWebEnabled,
  isPixleeWebEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import Notification from '@tcp/core/src/components/common/molecules/Notification';
import { PRODUCT_ADD_TO_BAG } from '@tcp/core/src/constants/reducer.constants';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary/errorBoundary';
import { isClient, getViewportInfo, getBrand, getWishListTrackingObj } from '@tcp/core/src/utils';
import getPdpBrandLabel from '@tcp/core/src/components/features/browse/ProductDetail/molecules/ProductBasicInfo/helpers/ProductBasicInfoHelper';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import injectWriteReviewReducer from '@tcp/core/src/components/features/browse/WriteReviewDetail/container/WriteReviewDynamicStore';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import { toSentenceCase } from '@tcp/core/src/components/common/organisms/ProductPickup/utils/ProductPickup.utils.js';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import {
  GLOBAL_COMMON_BROWSE_LABELS,
  globalCommonBrowseLabels,
} from '@tcp/core/src/utils/labels/globalCommonBrowseLabels.labels';
import { PDP_SUB_LABELS, pdpSubLabels } from '@tcp/core/src/utils/labels/browse/PDP.labels';
import {
  FavoriteLabels,
  FAVORITES_LABELS,
  lblFavPurchased,
} from '@tcp/core/src/components/features/browse/Favorites/labels/Favorites.labels.js';
import ProductRating from '../ProductRating/ProductRating';
import withStyles from '../../../../../common/hoc/withStyles';
import ProductBasicInfoStyle from './ProductBasicInfo.style';
import {
  BadgeItem,
  WishListIcon,
} from '../../../ProductListing/molecules/ProductList/views/ProductItemComponents';
import { setLoyaltyLocation } from '../../../../../../constants/analytics';
import { ZoneOneBadgesWrapper } from '../../../PlpTile/views/styles/ZoneOneBadges.style';
import ZoneOneBadges from '../../../PlpTile/views/ZoneOneBadges.view';
import { BadgesContext } from '../../../Badges/context/Badges.context';
import { MONTH_SHORT_FORMAT } from '../../../../../../utils/utils';
import { getZoneOneBadgesArray } from '../../../../../../utils/badge.util';

class ProductBasicInfo extends React.Component {
  itemSoldOutMessage = getLabelFromCopyOrFromTranslation(
    `${GLOBAL_COMMON_BROWSE_LABELS}.lbl_common_itemSoldOut`,
    globalCommonBrowseLabels
  );

  writeAReviewLabel = getLabelFromCopyOrFromTranslation(
    `${PDP_SUB_LABELS}.lbl_write_review`,
    pdpSubLabels
  );

  purchasedLabel = renderLabel(
    getLabelFromCopyOrFromTranslation(`${FAVORITES_LABELS}.${lblFavPurchased}`, FavoriteLabels),
    lblFavPurchased
  );

  static contextType = BadgesContext;

  constructor(props) {
    super(props);
    this.state = {
      clickedProdutId: '',
      isLoggedIn: props.isLoggedIn,
      hasMounted: false,
    };
  }

  static getDerivedStateFromProps(props, state) {
    const {
      isLoggedIn,
      onAddItemToFavorites,
      productInfo: { productId },
      productMiscInfo: { colorProductId, colorDisplayId },
      pageName,
      skuId,
      formName,
    } = props;
    const selectedColorId = colorDisplayId || productId;

    const { clickedProdutId, isLoggedIn: wasLoggedIn } = state;
    if (isLoggedIn && isLoggedIn !== wasLoggedIn && clickedProdutId === colorDisplayId) {
      onAddItemToFavorites({
        colorProductId: selectedColorId,
        productSkuId: (skuId && skuId.skuId) || null,
        pdpColorProductId: colorProductId,
        formName: formName || PRODUCT_ADD_TO_BAG,
        page: pageName || 'PDP',
      });
      return { clickedProdutId: '', isLoggedIn };
    }
    return null;
  }

  componentDidMount() {
    this.setState({ hasMounted: true });
  }

  componentDidUpdate() {
    const { countUpdated, resetCountUpdate } = this.props;
    if (countUpdated === true) resetCountUpdate();
  }

  componentWillUnmount() {
    const { removeAddToFavoritesErrorMsg, countUpdated, resetCountUpdate } = this.props;
    if (typeof removeAddToFavoritesErrorMsg === 'function') {
      removeAddToFavoritesErrorMsg('');
    }

    if (countUpdated === true) resetCountUpdate();
  }

  getTitle = ({ productMiscInfo, productInfo }) => {
    const currentColorProductId = productMiscInfo?.colorProductId;
    const name = productInfo?.allProductId?.find(
      (product) => product.productid === currentColorProductId
    )?.style_name;

    if (name) {
      return name;
    }
    return productInfo.name;
  };

  title = (outFitFavt) => {
    const {
      productInfo,
      className,
      isOutfitPage,
      reviewOnTop,
      bundleProductName,
      isStyleWith,
      colorProductName,
      isNewPDPEnabled,
      formValues,
      renderProductRatings,
      socialProofMessage,
      productMiscInfo,
      isGiftCard,
      isPDPRedesignEnabled,
      setPdpTabSectionIndex,
      deleteFavItemInProgressFlag,
      shouldRenderH1Title,
      isShowNonH1Title,
    } = this.props;
    const { hasMounted } = this.state;
    const handleAddRemoveFromWishlistObj = {
      handleAddToWishlist: this.handleAddToWishlist,
      handleRemoveFromWishList: this.handleRemoveFromWishList,
      deleteFavItemInProgressFlag,
    };
    if (isStyleWith) {
      return null;
    }

    const selectedColour = colorProductName || formValues?.color;
    const name = !bundleProductName
      ? this.getTitle({ productMiscInfo, productInfo })
      : bundleProductName;
    const headingType = shouldRenderH1Title || reviewOnTop ? 'h1' : 'h2';
    const fontSize = isNewPDPEnabled ? 'fs22' : 'fs18';
    const colorImageNameSuffix = productMiscInfo.imageName?.toLowerCase();
    let colorStr = String(selectedColour).toLowerCase();
    colorStr = colorStr.replace(`-${colorImageNameSuffix}`, '');

    const titleText = isNewPDPEnabled && colorStr && !isGiftCard ? `${name} - ${colorStr}` : name;

    const bodyCopy = (
      <BodyCopy
        className={`product-title ${className} ${isNewPDPEnabled ? 'new-pdp-colour' : ''}`}
        fontSize={isOutfitPage ? ['fs16', 'fs18'] : fontSize}
        component={isOutfitPage || (isShowNonH1Title && !hasMounted) ? 'p' : headingType}
        fontFamily="secondary"
        fontWeight="extrabold"
        tabIndex={0}
      >
        {titleText}
      </BodyCopy>
    );

    const ratings = isNewPDPEnabled && (
      <div
        className={`rating-section-bottom ${
          isPDPRedesignEnabled ? 'rating-section-bottom-redesigned' : 'show-on-desktop'
        }`}
      >
        {renderProductRatings(
          productInfo,
          true,
          isNewPDPEnabled,
          socialProofMessage,
          isGiftCard,
          isPDPRedesignEnabled,
          setPdpTabSectionIndex,
          handleAddRemoveFromWishlistObj,
          outFitFavt
        )}
      </div>
    );

    return (
      <>
        {bodyCopy}
        {ratings}
      </>
    );
  };

  handleAddToWishlist = () => {
    const {
      onAddItemToFavorites,
      productInfo: { productId },
      productMiscInfo: { colorProductId, colorDisplayId },
      pageName,
      skuId,
      formName,
      checkForOOSForVariant,
      deleteFavItemInProgressFlag,
      isLoggedIn,
      trackWishListClick,
    } = this.props;
    if (checkForOOSForVariant || deleteFavItemInProgressFlag) {
      return;
    }
    const selectedColorId = colorDisplayId || productId;
    if (isClient()) {
      const loyaltyLocation = `favorites|${pageName || 'PDP'}`;
      setLoyaltyLocation(loyaltyLocation);
      const wishListObj = getWishListTrackingObj(loyaltyLocation, isLoggedIn);
      trackWishListClick(wishListObj);
    }
    onAddItemToFavorites({
      colorProductId: selectedColorId,
      productSkuId: (skuId && skuId.skuId) || null,
      pdpColorProductId: colorProductId,
      formName: formName || PRODUCT_ADD_TO_BAG,
      page: pageName || 'PDP',
    });
    this.setState({
      clickedProdutId: selectedColorId,
    });
  };

  handleRemoveFromWishList = () => {
    const {
      productInfo,
      onSetLastDeletedItemIdAction,
      productMiscInfo: { newItemId },
      checkForOOSForVariant,
      wishList,
      deleteFavItemInProgressFlag,
    } = this.props;
    if (checkForOOSForVariant || deleteFavItemInProgressFlag) {
      return;
    }
    const itemId = productInfo?.productId;
    const wishListProducts = wishList?.items;
    const itemIdFromWishlist = wishListProducts.filter((product) => {
      return product?.productInfo?.generalProductId === itemId;
    });
    const selectedWishList = wishList?.id;
    if (selectedWishList) {
      onSetLastDeletedItemIdAction({
        externalId: selectedWishList,
        productId: productInfo?.productId,
        itemId: newItemId || itemIdFromWishlist[0]?.itemInfo?.itemId,
        notFromFavoritePage: true,
        wishListName: wishList?.displayName,
      });
    }
  };

  onLinkClick = (e) => {
    e.preventDefault();
    const {
      setProductDataForReviewActn,
      primaryBrand,
      alternateBrand,
      productMiscInfo,
      productInfo,
    } = this.props;
    const { colorDisplayId } = productMiscInfo || {};
    const { ratingsProductId, name } = productInfo || {};
    setProductDataForReviewActn({
      isWriteReviewModalOpen: true,
      productDataForReview: {
        primaryBrand: primaryBrand || alternateBrand,
        productName: name,
        colorDisplayId,
        ratingsProductId,
      },
    });
  };

  handleWriteReviewClick = async (e, isPixleeWidget, isBVWidget) => {
    if (isPixleeWidget) {
      window.TurnToCmd('reviewsList.writeReview');
    } else if (isBVWidget) {
      await injectWriteReviewReducer();
      this.onLinkClick(e);
    }
  };

  checkForPreviouslyPuchasedBadge = (zoneOneBadges) => {
    const { previouslyPurchasedBadgeData, productId, isLoggedIn, isPrevPurchasedBadgeEnable } =
      this.context;
    if (!isPrevPurchasedBadgeEnable || !isLoggedIn) return zoneOneBadges;

    let ppLabel = '';
    if (isEmpty(previouslyPurchasedBadgeData)) {
      ppLabel = '';
    }
    const prevPProduct = previouslyPurchasedBadgeData?.find(
      (ppProduct) => ppProduct?.productId === productId
    );
    const orderDate = prevPProduct?.items[0]?.orderDate;

    Object?.entries(MONTH_SHORT_FORMAT)?.forEach(([key, value]) => {
      if (orderDate) {
        const [year, month] = orderDate?.split('-');
        if (value === month) {
          ppLabel += `${key} ${year}`;
        }
      }
    });

    if (ppLabel) {
      return getZoneOneBadgesArray({
        zoneOneBadges,
        previouslyPurchasedBadge: `${this.purchasedLabel} ${ppLabel}`,
      });
    }
    return zoneOneBadges;
  };

  renderBadge = () => {
    const { zoneOneBadges } = this.props;
    const zoneOneBadgesNew = this.checkForPreviouslyPuchasedBadge(zoneOneBadges);
    if (zoneOneBadgesNew?.length > 0) {
      return (
        <ZoneOneBadgesWrapper>
          {zoneOneBadgesNew.map((badge) => {
            return (
              <ZoneOneBadges key={badge.priority.toString()} type={badge.type} text={badge.label} />
            );
          })}
        </ZoneOneBadgesWrapper>
      );
    }
    return null;
  };

  renderHeader = ({
    className,
    isShowBrandNameEnabled,
    brandLabel,
    isNewPJPPDPRedesignEnabled,
    isMobile,
    isNewPDPEnabled,
    isGiftCard,
    keepAlive,
    errorMessages,
    currentColorId,
    isPixleeWidget,
    isBVWidget,
    pdpUrl,
    asPath,
    title,
    bigIdeaLicensedProductBrand,
    isLicensed,
    isClickableBrandBadgesEnabled,
  }) => {
    return (
      <div className={`product-details-header-container ${className}`}>
        <div className="sub-header-wrapper">
          <div>
            {this.renderBadge()}
            {isShowBrandNameEnabled && !(isLicensed && isClickableBrandBadgesEnabled) ? (
              <BodyCopy
                fontSize="fs18"
                fontWeight="bold"
                fontFamily="secondary"
                className="product-brand-new"
              >
                {brandLabel}
              </BodyCopy>
            ) : null}
            {isLicensed && bigIdeaLicensedProductBrand && isClickableBrandBadgesEnabled && (
              <Anchor
                to={`/search?searchQuery=*?TCPBigIdeaLicensedProductBrand_uFilter=${bigIdeaLicensedProductBrand}`}
                asPath={`/search/*?TCPBigIdeaLicensedProductBrand_uFilter=${bigIdeaLicensedProductBrand}`}
                className="product-brand-licensed"
              >
                {toSentenceCase(bigIdeaLicensedProductBrand)}
              </Anchor>
            )}
          </div>
          {!isNewPJPPDPRedesignEnabled && isMobile && isNewPDPEnabled && !isGiftCard && (
            <BodyCopy
              className="newwrite-review-link"
              fontFamily="secondary"
              fontSize="fs12"
              component="span"
              onClick={(e) => this.handleWriteReviewClick(e, isPixleeWidget, isBVWidget)}
            >
              {this.writeAReviewLabel}
            </BodyCopy>
          )}
        </div>
        {keepAlive && (
          <BodyCopy color="red.500" fontSize="fs10" fontFamily="secondary">
            {this.itemSoldOutMessage}
          </BodyCopy>
        )}
        {errorMessages &&
          errorMessages[currentColorId] &&
          errorMessages[currentColorId].itemId === currentColorId && (
            <Notification
              status="error"
              colSize={{ large: 12, medium: 8, small: 6 }}
              message={errorMessages[currentColorId].errorMessage}
            />
          )}
        <div className="information-container">
          <div className="title-wrapper-new">
            {typeof pdpUrl === 'string' ? (
              <Anchor to={pdpUrl} asPath={asPath} className="product-link-title">
                {title}
              </Anchor>
            ) : (
              title
            )}
          </div>
        </div>
      </div>
    );
  };

  // eslint-disable-next-line
  render() {
    const {
      asPath,
      pdpUrl,
      badge,
      isGiftCard,
      className,
      reviewOnTop,
      isLoggedIn,
      productInfo: {
        ratingsProductId,
        ratings,
        productId,
        reviewsCount,
        unbxdRatings,
        unbxdReviewsCount,
      },
      keepAlive,
      productMiscInfo: {
        colorDisplayId,
        isFavorite,
        miscInfo,
        favoritedCount,
        bigIdeaLicensedProductBrand,
        isLicensed,
      },
      isInWishList,
      hideRating,
      isStyleWith,
      deleteFavItemInProgressFlag,
      isOutfitPage,
      errorMessages,
      pageName,
      socialProofMessage,
      isNewPDPEnabled,
      isShowBrandNameEnabled,
      primaryBrand,
      alternateBrand,
      isFbt,
      isNewPJPPDPRedesignEnabled,
      setPdpTabSectionName,
      isBundleProduct,
      isBVWidget,
      isPixleeWidget,
      isPDPRedesignEnabled,
      setPdpTabSectionIndex,
      isClickableBrandBadgesEnabled,
    } = this.props;
    const isFavoriteView = false;
    const isFavorited = isFavorite || (miscInfo && miscInfo.isInDefaultWishlist) || isInWishList;
    const outFitFavt = isOutfitPage ? isFavorited : isInWishList;
    const title = this.title(outFitFavt);
    const handleAddRemoveFromWishlistObj = {
      handleAddToWishlist: this.handleAddToWishlist,
      handleRemoveFromWishList: this.handleRemoveFromWishList,
      deleteFavItemInProgressFlag,
    };
    const currentColorId = colorDisplayId || productId;
    const prodBrand = getBrand() && getBrand().toUpperCase();
    const { isMobile } = isClient() && getViewportInfo();
    const brandLabel = getPdpBrandLabel({ primaryBrand, alternateBrand, prodBrand });

    if (isPDPRedesignEnabled) {
      return this.renderHeader({
        className,
        isShowBrandNameEnabled,
        brandLabel,
        isNewPJPPDPRedesignEnabled,
        isMobile,
        isNewPDPEnabled,
        isGiftCard,
        keepAlive,
        errorMessages,
        currentColorId,
        isPixleeWidget,
        isBVWidget,
        pdpUrl,
        asPath,
        title,
        setPdpTabSectionIndex,
        bigIdeaLicensedProductBrand,
        isLicensed,
        isClickableBrandBadgesEnabled,
      });
    }

    return (
      <div className={`product-details-header-container ${className}`}>
        <div className="sub-header-wrapper">
          <div>
            {!isStyleWith && !isFbt && (
              <BadgeItem
                customFontWeight="regular"
                customFontSize={['fs10', 'fs10', 'fs10']}
                className="inline-badge-item"
                text={badge}
              />
            )}
            {isShowBrandNameEnabled ? (
              <BodyCopy
                fontSize="fs18"
                fontWeight="bold"
                fontFamily="secondary"
                className="product-brand"
              >
                {brandLabel}
              </BodyCopy>
            ) : null}
          </div>
          {!isNewPJPPDPRedesignEnabled && isMobile && isNewPDPEnabled && !isGiftCard && (
            <BodyCopy
              className="newwrite-review-link"
              fontFamily="secondary"
              fontSize="fs12"
              component="span"
              onClick={(e) => this.handleWriteReviewClick(e, isPixleeWidget, isBVWidget)}
            >
              {this.writeAReviewLabel}
            </BodyCopy>
          )}
        </div>

        {keepAlive && (
          <BodyCopy color="red.500" fontSize="fs10" fontFamily="secondary">
            {this.itemSoldOutMessage}
          </BodyCopy>
        )}

        {errorMessages &&
          errorMessages[currentColorId] &&
          errorMessages[currentColorId].itemId === currentColorId && (
            <Notification
              status="error"
              colSize={{ large: 12, medium: 8, small: 6 }}
              message={errorMessages[currentColorId].errorMessage}
            />
          )}
        <div className="information-container">
          <div className="title-wrapper">
            {typeof pdpUrl === 'string' ? (
              <Anchor to={pdpUrl} asPath={asPath} className="product-link-title">
                {title}
              </Anchor>
            ) : (
              title
            )}

            {!isGiftCard && !isStyleWith && !isFbt && !isNewPDPEnabled && !isBundleProduct && (
              <div className="wishlist-container">
                {WishListIcon({
                  isFavoriteView,
                  isInDefaultWishlist: outFitFavt,
                  handleAddRemoveFromWishlistObj,
                  itemNotAvailable: false,
                  favoritedCount,
                })}
              </div>
            )}
          </div>
          {/* TODO - fix it with bundle product requirement */}
          {/* {!isBundleProduct && !isGiftCard && isRatingsVisible && <ProductRating ratingsProductId={ratingsProductId} /> } */}
          {!hideRating && !isGiftCard && !isStyleWith && !isFbt && !isNewPDPEnabled ? (
            <ProductRating
              ratingsProductId={ratingsProductId}
              ratings={ratings || unbxdRatings || 0}
              reviewOnTop={reviewOnTop}
              isLoggedIn={isLoggedIn}
              reviews={reviewsCount || unbxdReviewsCount}
              pageName={pageName}
              socialProofMessage={socialProofMessage}
              isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
              setPdpTabSectionName={setPdpTabSectionName}
            />
          ) : null}
        </div>
        {/* TODO - the favourite functionality needs to be implemented here */}
        {/* {!isBundleProduct && !isGiftCard && (
                <FavoriteButtonContainer isActiveHoverMessage uniqueId={uniqueId} favoritedCount={colorSlice.favoritedCount}
                  generalProductId={generalProductId} colorProductId={colorSlice.colorProductId} skuId={skuId} quantity={quantity}
                  isInDefaultWishlist={isInDefaultWishlist} isShowFavoriteCount={isShowFavoriteCount} />
              )} */}
        {/* TODO - fix it with bundle product requirement */}
        {/* {!isBundleProduct && !isMobile && keepAlive && <div className="oos-message">OUT OF STOCK</div>} */}
      </div>
    );
  }
}

ProductBasicInfo.propTypes = {
  className: PropTypes.string,
  productInfo: PropTypes.shape({}).isRequired,
  asPath: PropTypes.string,
  pdpUrl: PropTypes.string,
  badge: PropTypes.string,
  isGiftCard: PropTypes.bool.isRequired,
  onAddItemToFavorites: PropTypes.func.isRequired,
  keepAlive: PropTypes.bool,
  productMiscInfo: PropTypes.shape({
    isInDefaultWishlist: PropTypes.bool,
  }),
  removeAddToFavoritesErrorMsg: PropTypes.func,
  pageName: PropTypes.string,
  skuId: PropTypes.string,
  isLoggedIn: PropTypes.bool,
  formName: PropTypes.string,
  isOutfitPage: PropTypes.bool,
  reviewOnTop: PropTypes.bool,
  isInWishList: PropTypes.bool.isRequired,
  hideRating: PropTypes.bool,
  bundleProductName: PropTypes.string,
  countUpdated: PropTypes.bool,
  resetCountUpdate: PropTypes.func.isRequired,
  socialProofMessage: PropTypes.string,
  isStyleWith: PropTypes.bool,
  checkForOOSForVariant: PropTypes.bool.isRequired,
  onSetLastDeletedItemIdAction: PropTypes.func,
  wishList: PropTypes.shape({}),
  deleteFavItemInProgressFlag: PropTypes.bool,
  errorMessages: PropTypes.shape({}),
  isNewPDPEnabled: PropTypes.bool,
  colorProductName: PropTypes.string,
  isShowBrandNameEnabled: PropTypes.bool,
  renderProductRatings: PropTypes.func,
  primaryBrand: PropTypes.string,
  formValues: PropTypes.shape({}),
  trackWishListClick: PropTypes.func,
  setProductDataForReviewActn: PropTypes.func,
  alternateBrand: PropTypes.string,
  isNewPJPPDPRedesignEnabled: PropTypes.bool,
  setPdpTabSectionName: PropTypes.func,
  shouldRenderH1Title: PropTypes.bool,
};

ProductBasicInfo.defaultProps = {
  className: '',
  asPath: null,
  pdpUrl: null,
  badge: '',
  keepAlive: false,
  productMiscInfo: {
    isInDefaultWishlist: false,
  },
  pageName: '',
  skuId: '',
  removeAddToFavoritesErrorMsg: () => {},
  isLoggedIn: false,
  formName: PRODUCT_ADD_TO_BAG,
  isOutfitPage: false,
  reviewOnTop: false,
  hideRating: false,
  bundleProductName: '',
  countUpdated: false,
  isStyleWith: false,
  onSetLastDeletedItemIdAction: () => {},
  socialProofMessage: '',
  wishList: {},
  deleteFavItemInProgressFlag: false,
  errorMessages: {},
  isNewPDPEnabled: false,
  colorProductName: '',
  isShowBrandNameEnabled: false,
  renderProductRatings: () => {},
  primaryBrand: '',
  formValues: {},
  trackWishListClick: () => {},
  setProductDataForReviewActn: () => {},
  alternateBrand: '',
  isNewPJPPDPRedesignEnabled: false,
  setPdpTabSectionName: () => {},
  shouldRenderH1Title: false,
};

const mapStateToProps = (state) => ({
  isPixleeWidget: isPixleeWebEnabled(state),
  isBVWidget: isBVWebEnabled(state),
});
const ProductBasicInfoContainer = connect(mapStateToProps, null)(ProductBasicInfo);
export default errorBoundary(withStyles(ProductBasicInfoContainer, ProductBasicInfoStyle));
